<template>
  <v-card flat>
    <!-- <form @submit.prevent="update" @keydown="form.onKeydown($event)"> -->
    <v-card-title primary-title>
      <h3 class="display-1 mb-3" style="width: 100%;">Verknüpfte Leistungen / Suchbegriffe</h3>
      <h5 class="subheading mb-0">Hier können Sie sehen, mit welchen Leistungen Ihr Betrieb aktuell verknüpft ist:</h5>
    </v-card-title>
    <v-card-text>

 <v-list two-line>
    <template v-for="(leistung) in leistungen">
        <v-list-tile
        :key="leistung.leistung"
        avatar
      >
        <v-list-tile-avatar>
          <img :src="leistung.gewerk.logo">
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ leistung.leistung }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ leistung.gewerk.name }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
 </v-list>

      <p
        class="subheading"
      >Änderungen nehmen wir im Moment noch manuell vor, bitte schicken Sie uns dafür eine Liste, der von Ihnen angebotenen Leistungen, an:
        <br>
      </p>

      <v-btn href="mailto:info@lokaleshandwerk.de">
        <v-icon left>mail</v-icon>info@lokaleshandwerk.de
      </v-btn>

    <v-layout row class="mt-3">
        <v-spacer></v-spacer> 
        <v-btn @click="nexttab()" large>Weiter <v-icon right>chevron_right</v-icon></v-btn>
    </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
// import Form from "vform";
// import axios from 'axios'
// import draggable from 'vuedraggable'

export default {
  props: {
    leistungen: Array,
    betrieb: ''
  },
  name: 'suchbegriffe-view',
  methods: {
    nexttab (event) {
      this.$emit('tabswitch')
    }
  },

  // mounted () {
  //   const app = this
  //   // var LeistungenListe
  //   axios.get('/api/v1/meineleistung')
  //     .then(function (resp) {
  //       app.company = resp.data

  //       // LeistungenListe = app.company
  //     })
  //     .catch(function () {
  //       // alert("Konnte Firma nicht laden")
  //     })
  // },
  data () {
    return {
      ex7: false,

      e7: [],
      enabled: true,
      dragging: false
    }
  }
}
</script>

<style scoped>
.button {
  margin-top: 35px;
}
.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}
input {
  display: inline-block;
  width: 50%;
}
.text {
  margin: 20px;
}
</style>

